import { useQuery } from '@apollo/client';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import type { CuiOptionType } from '@crehana/ui';
import { notEmpty } from '@crehana/utils';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';

import GET_ORGANIZATION_ATTRIBUTES from './graphql/OrganizationAttrs.v4.b2b.graphql';
import type {
  OrganizationAttrs,
  OrganizationAttrsVariables,
} from './graphql/types/OrganizationAttrs';

const useOrganizationAttrs = () => {
  const { slug } = useAdminDashboard();
  const { data, refetch, loading, updateQuery } = useQuery<
    OrganizationAttrs,
    OrganizationAttrsVariables
  >(GET_ORGANIZATION_ATTRIBUTES, {
    variables: {
      slug,
    },
    context: { clientName: 'v4.b2b' },
  });

  const totalCount = data?.b2bAttribute?.length || 0;

  const attributes = data?.b2bAttribute?.filter(notEmpty) || [];

  const attributesAsOptions = attributes.map(
    attr =>
      ({
        label: attr.name,
        value: attr.originalId,
        tags:
          attr.tags?.filter(notEmpty).map(tag => ({
            value: tag.originalId as string,
            label: tag?.name || '',
          })) || [],
      }) as CuiOptionType<string>,
  );

  return {
    refetch,
    loading,
    attributes,
    attributesAsOptions,
    totalCount,
    updateQuery,
  };
};

export default useOrganizationAttrs;
